import script from "./message.vue?vue&type=script&lang=ts&setup=true"
export * from "./message.vue?vue&type=script&lang=ts&setup=true"

import "./message.vue?vue&type=style&index=0&id=4615cff9&lang=scss&scoped=true"

import exportComponent from "/home/crmfront/lineCRM-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4615cff9"]])

export default __exports__